



























import WForm from "./WForm.vue";
import { Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class WFormX extends WForm {
	@Prop({ type: String, required: true })
	title!: String;

	@Emit()
	submit(e: any) {}

	isSubmit(field: any) {
		return field.field === "submit";
	}
}
